module.exports = __webpack_public_path__ + "static/img/coupon_two.2ca329a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coupon_two.png
// module id = UIf3
// module chunks = 0